<template>
  <div v-show="lastCommentedTime" class="comment-summary-info">
    <span class="label">{{ t("comment_last_commented_time_label") }}</span>
    <time>{{ `${lastCommentedTime}` }}</time>
  </div>
</template>

<script setup lang="ts">
import store from "@plugins/comment/components/CommentStore";
import DOMUtils from "@utils/dom.utils";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useVm } from "@utils/vm.ts";

// Props
interface Props {
  resourceUuid: string;
  resourceType: string;
}

const props = defineProps<Props>();

const { vm } = useVm();
const { t } = useI18n();

// Computed
const lastCommentedTime = computed(() => {
  const commentTime = store.getLastCommentedTime(props.resourceUuid);

  if (commentTime && commentTime !== "") {
    const parentCard = DOMUtils.parent(vm.$el, ".card-component");
    DOMUtils.addClass(parentCard, "has-comment");
    return commentTime;
  }

  return "";
});
</script>

<style lang="scss">
@import "@styles/themes/sls-theme/tokens/spacing";
@import "@styles/themes/sls-theme/tokens/typo";

.comment-summary-info {
  @include carbon--type-style("card-label-01", true);
  flex: 0 0 100%;
  margin-bottom: $spacing-05;
}
</style>
